import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CDN_BASE_URL } from "../../../config";
import { priceComma } from "../../../utils/priceComma";
import { getTiming } from "../../../utils/getTiming";
import { ProductContext } from "../../../context/ProductContext";
import { FaSearch } from "react-icons/fa";

const ProductsCard = ({ data }) => {
  const { name, price, img, createdAt, url, _id, year, vehicle_number } = data;
  const { setselectProduct } = useContext(ProductContext);

  const now = new Date();
  const newTime = now.getTime() - new Date(createdAt).getTime();
  const hour = newTime / 86400000;

  console.log(data?.no_price);

  return (
    <div className="border-brand grid grid-cols-12 overflow-hidden show_hidden_button">
      <span className="col-span-5">
        <Link
          to={`/${url?.category?.url}/${url?.brand?.name}/${url?.name}/${vehicle_number}`}
          title={`مشخصات محصول ${name}`}
        >
          {img?.img_webp ? (
            <picture>
              <source type="image/webp" srcset={CDN_BASE_URL + img?.img_webp} />
              <img
                src={CDN_BASE_URL + img?.img_jpg}
                alt={name}
                className="w-full h-[115px] xl:h-[130px] object-cover object-center"
                loading="lazy"
              />
            </picture>
          ) : img ? (
            <img
              src={CDN_BASE_URL + img}
              alt={name}
              className="w-full h-[115px] xl:h-[130px] object-cover object-center"
              loading="lazy"
            />
          ) : (
            <img
              loading="lazy"
              src={"/no-image.jpg"}
              alt={name}
              className="w-full h-[115px] xl:h-[130px] object-cover object-center"
            />
          )}
        </Link>
      </span>
      <span className="col-span-7 p-3 flex flex-col gap-3 relative ">
        <div className="absolute left-0 top-0 w-full h-full bg-[#fff]/20 backdrop-blur-sm flex items-center justify-center duration-200 opacity-0">
          <Link
            to={`/${url?.category?.url}/${url?.brand?.name}/${url?.name}/${vehicle_number}`}
            title={`اطلاعات ${name}`}
            className="bg-black text-white p-1 rounded text-secendory"
          >
            {name}
            
          </Link>
        </div>
        <h3 className="text-[12px] 2xl:text-[16px] font-[600] flex justify-between items-center">
          {name}
          <span className="text-[10px] 2xl:text-[14px] font-[500]">
            مدل:{year}
          </span>
        </h3>
        <p className="text-[10px] 2xl:text-[14px]">{getTiming(hour)}</p>
        <h5 className="text-[16px] 2xl:text-[20px] font-[600] mt-2" dir="ltr">
          {data?.no_price
            ? "توافقی"
            : priceComma(Number(price * 1000000000).toFixed(0), 2)}
        </h5>
      </span>
    </div>
  );
};

export default ProductsCard;
